export const useRefreshToken = () => {
	const refreshToken = useCookie('refresh_token')
	const accessToken = useCookie('access_token')

	return async () => {
		const response = await $fetch(useRuntimeConfig().public.baseUrl + '/token/', {
			method: 'POST',
			body: {
				refresh_token: refreshToken.value,
			},
		})

		if (!response.access_token) {
			throw new Error('Failed to refresh token')
		}
		accessToken.value = response.access_token

		return response.access_token
	}
}

export const createFetchInstance = (baseURL) => {
	const refreshToken = useCookie('refresh_token')
	const accessToken = useCookie('access_token')
	const refreshCrmToken = useRefreshToken()

	return $fetch.create({
		baseURL: baseURL,

		async onRequest({ options }) {
			if (accessToken.value) {
				options.headers = {
					...(options.headers || {}),
					Authorization: `Bearer ${accessToken.value}`,
				}
			}
		},

		retryStatusCodes: [401, 403],

		async retry({ response }) {
			return response.status === 401 || response.status === 403
		},

		async onResponseError({ response, request, options }) {
			const { $store } = useNuxtApp()
			if (
				(response.status === 401 || response.status === 403) &&
				!request.includes('token')
			) {
				if (!refreshToken.value) {
					$store.dispatch('login/logout', { root: true })
					return navigateTo('/login')
				}

				try {
					const newToken = await refreshCrmToken()
					if (newToken) {
						return await $fetch(request, {
							...options,
							headers: {
								...(options.headers || {}),
								Authorization: `Bearer ${newToken}`,
							},
						})
					}
				} catch {
					useCookie('access_token').value = null
					useCookie('refresh_token').value = null
					$store.dispatch('login/logout', { root: true })
					return navigateTo('/login')
				}
			}
		},
	})
}
